import type { ItemWithInstanceCounts, InventorySortBy, SortOrder } from '../types';

export function sortItems(
  items: ItemWithInstanceCounts[],
  sortBy: InventorySortBy,
  sortOrder: SortOrder,
  getDisplayName?: (item: ItemWithInstanceCounts) => string
): ItemWithInstanceCounts[] {
  const sorted = [...items];
  const resolveName =
    getDisplayName ??
    ((item: ItemWithInstanceCounts) =>
      item.customName || (item.product as { name?: string } | null)?.name || '');

  sorted.sort((a, b) => {
    let comparison = 0;
    switch (sortBy) {
      case 'expiry_date': {
        const aExp = a.earliestExpiryDate;
        const bExp = b.earliestExpiryDate;
        if (!aExp && !bExp) {
          comparison = 0;
          break;
        }
        if (!aExp) return 1; // nulls always at end
        if (!bExp) return -1;
        comparison = aExp.localeCompare(bExp);
        break;
      }
      case 'name':
        comparison = resolveName(a).toLowerCase().localeCompare(resolveName(b).toLowerCase());
        break;
      case 'created_at':
        comparison = new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
        break;
    }
    return sortOrder === 'asc' ? comparison : -comparison;
  });
  return sorted;
}
